import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { BestDealFlagEnum } from '@shared/enums/best-deal-flag.enum';
import { BestDealsBetterDealModel, BestDealsModel } from '@shared/models/best-deals.model';
import { bestBetterDealAdapter } from '@shared/store/best-better-deals/best-better-deals.reducer';
import { BestBetterDealState } from '@shared/store/best-better-deals/best-better-deals.state';

const { selectEntities } = bestBetterDealAdapter.getSelectors();
export const selectBestBetterDealsState = createFeatureSelector<BestBetterDealState>('bestBetterDeals');

export const selectIsLoadingBestBetterDeals = createSelector(
  selectBestBetterDealsState,
  (state: BestBetterDealState): boolean => state.loading,
);

export const selectBestBetterDealsEntities = createSelector(selectBestBetterDealsState, (bestBetterDeal: BestBetterDealState) =>
  selectEntities(bestBetterDeal),
);

export const selectBestBetterDeals = createSelector(selectBestBetterDealsEntities, (bestBetterDealEntities): BestDealsModel[] =>
  Object.values(bestBetterDealEntities),
);

export const selectBestBetterDealsByMortgageId = (mortgageId: string): MemoizedSelector<object, BestDealsBetterDealModel[]> =>
  createSelector(
    selectBestBetterDealsState,
    (bestBetterDeal: BestBetterDealState): BestDealsBetterDealModel[] => bestBetterDeal?.entities[mortgageId]?.bestDeals,
  );

export const selectBiggestSavingDealByMortgageId = (mortgageId: string): MemoizedSelector<object, BestDealsBetterDealModel> =>
  createSelector(
    selectBestBetterDealsState,
    (bestBetterDeal: BestBetterDealState): BestDealsBetterDealModel =>
      bestBetterDeal?.entities[mortgageId]?.bestDeals?.find((d) => d.flag == BestDealFlagEnum.BiggestSaving),
  );
